import angular from 'angular';
import RetailerSettingsComponent from './retailer-settings-component';

export default angular.module('retailer-settings', []).component('retailerSettings', new RetailerSettingsComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/retailer-settings/retailer-settings-module.js